import SectionHeading from '../components/SectionHeading';
import Reveal from '../components/Reveal';

const checklist = ['Zufahrt', 'Aufstellfläche', 'Betonmenge', 'Terminfenster', 'Pumpweg', 'Kontaktperson'];

function PlanningSection() {
  return (
    <section className="py-12 sm:py-16 md:py-28">
      <div className="container-site mx-auto">
        <div className="grid lg:grid-cols-[0.95fr_minmax(320px,0.8fr)] gap-8 lg:gap-16 items-center">
          <Reveal>
            <div className="min-h-[260px] sm:min-h-[360px] lg:min-h-[520px] rounded-card overflow-hidden shadow-elevated">
              <img
                src="/assets/img/coordination-900.webp"
                srcSet="/assets/img/coordination-700.webp 700w, /assets/img/coordination-900.webp 900w"
                sizes="(max-width: 640px) calc(100vw - 2rem), (max-width: 1024px) calc(100vw - 2rem), 580px"
                alt="Betonpumpe und Fahrmischer auf einer Baustelle"
                width="900"
                height="506"
                loading="lazy"
                className="w-full h-full object-cover saturate-[0.96] contrast-[1.03]"
              />
            </div>
          </Reveal>

          <div className="py-2">
            <Reveal>
              <SectionHeading
                eyebrow="Planung"
                title="Vorher klären, was später Zeit spart."
                compact
              />
            </Reveal>
            <Reveal delay={100}>
              <p className="text-ink-soft text-base sm:text-lg leading-relaxed mt-4">
                Gute Betonlogistik beginnt vor der Anfahrt. Deshalb fragt MH-BETON nicht nur nach Menge und Adresse,
                sondern auch nach Zufahrt, Pumpstrecke, Entladezone und der Mannschaft vor Ort.
              </p>
            </Reveal>
            <Reveal delay={200}>
              <div className="flex flex-wrap gap-2 mt-6">
                {checklist.map((item) => (
                  <span
                    key={item}
                    className="px-3 py-1.5 rounded-full bg-white/80 border border-teal/15 text-signal-dark font-bold text-sm"
                  >
                    {item}
                  </span>
                ))}
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}

export default PlanningSection;
